import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import logo from './img/logo_a.png'

export const App = () => {

  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState({
    // 1. Datos Generales
    nombreEvento: '', fechaEvento: '', fechaLimite: '', presupuesto: '',
    empresa: '', sitioWeb: '', descripcionProducto: '',

    // 2. Características del Espacio
    noStand: '', medidasStand: '', tipoStand: '', niveles: '', alturaMaxima: '',

    // 3. Identidad y Materiales
    infoAdicional: '', visualizacionStand: '',

    // 4. Distribución y Necesidades
    counter: '', bodega: '', bodegaEquipamiento: [], frigobar: '',
    zonaNetworking: [], zonaLounge: '', rigging: '',
    activacion: '', activacionDetalle: '', papeleria: '', tipoPapeleria: '',
    contactos: '', basura: '', otroEspacio: '', otroEspacioDetalle: '',

    // 5. Exhibición de Producto
    tipoProducto: [], pesoEstimado: '', tipoExhibicion: [], exhibicionOtroDetalle: '',

    // 6. Tecnología, Servicios y Acabados
    pantallasTv: '', pantallasLed: '', pantallasTouch: '', lentesVr: '', tabletas: '',
    equipoSonido: false, serviciosTecnicos: [], acabadosPiso: []
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' && name === 'equipoSonido' ? checked : value
    }));
  };

  const handleArrayChange = (category, value) => {
    setFormData(prev => {
      const list = prev[category];
      return {
        ...prev,
        [category]: list.includes(value)
          ? list.filter(item => item !== value)
          : [...list, value]
      };
    });
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      alert('El archivo es demasiado grande. El límite es 10MB.');
      e.target.value = '';
      return;
    }

    setFormData(prev => ({
      ...prev,
      [fieldName]: file
    }));
  };

  const compressImage = (file) => {
    return new Promise((resolve) => {
      if (!file.type.startsWith('image/')) {
        resolve(file);
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const MAX_WIDTH = 1920;
          let width = img.width;
          let height = img.height;

          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');

          // Limpiar el lienzo antes de dibujar
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);

          // Detectar si el archivo original es PNG
          const isPng = file.type === 'image/png';
          const mimeType = isPng ? 'image/png' : 'image/jpeg';
          const extension = isPng ? '.png' : '.jpg';

          // En PNG toBlob ignora el parámetro de calidad para mantener sin pérdidas la transparencia
          const quality = isPng ? undefined : 0.7;

          canvas.toBlob(
            (blob) => {
              const compressedFile = new File(
                [blob],
                file.name.replace(/\.[^/.]+$/, "") + extension,
                {
                  type: mimeType,
                  lastModified: Date.now(),
                }
              );
              resolve(compressedFile);
            },
            mimeType,
            quality
          );
        };
      };
    });
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = (error) => reject(error);
    });
  };

  /*const handleSubmit = async (e) => {
    e.preventDefault();
    const scriptURL = 'https://script.google.com/macros/s/AKfycbxrfKCWMSgE_Qtggxd08pe5fQN59MI9ONK3xGAL_efHECo8lkUylELURUQBFrfVP5g/exec';

    console.log("formData", formData);
    try {
      setIsLoading(true);

      await fetch(scriptURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8', // CAMBIO CLAVE: Permite enviar JSON a Apps Script sin bloqueos CORS
        },
        body: JSON.stringify(formData)
      });

      alert('¡Brief registrado exitosamente en Google Sheets!');
      // cleanForm();
    } catch (error) {
      console.error('Error al conectar con el servidor:', error);
      alert('Hubo un problema al enviar el formulario. Intenta nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };*/

  const handleSubmit = async (e) => {
    e.preventDefault();
    const scriptURL = 'https://script.google.com/macros/s/AKfycbxrfKCWMSgE_Qtggxd08pe5fQN59MI9ONK3xGAL_efHECo8lkUylELURUQBFrfVP5g/exec';

    try {
      setIsLoading(true);

      const payload = { ...formData };
      const fileFields = ['planoUbicacion', 'manualExpositor', 'manualIdentidad', 'logotipo', 'reference', 'fichaTecnica'];

      for (const field of fileFields) {
        const rawFile = formData[field];

        // Verificar si el campo contiene un archivo File seleccionado
        if (rawFile && rawFile instanceof File) {
          console.log(`Procesando y comprimiendo: ${field}`);

          const fileToUpload = await compressImage(rawFile);
          const base64Data = await fileToBase64(fileToUpload);

          const uploadResponse = await fetch(scriptURL, {
            method: 'POST',
            headers: {
              'Content-Type': 'text/plain;charset=utf-8',
            },
            body: JSON.stringify({
              action: 'uploadFile',
              base64: base64Data,
              fileName: fileToUpload.name,
              mimeType: fileToUpload.type
            })
          });

          const uploadResult = await uploadResponse.json();

          if (uploadResult.status === 'success') {
            // Asignar la URL generada al payload
            payload[field] = uploadResult.fileUrl;
            console.log(`Archivo subido exitosamente (${field}):`, uploadResult.fileUrl);
          } else {
            throw new Error(`Error al subir el archivo ${rawFile.name}: ${uploadResult.message}`);
          }
        } else if (typeof rawFile !== 'string') {
          payload[field] = ''; // Si no hay archivo cargado
        }
      }

      // 4. Enviar el registro completo a Google Sheets con las URLs ya listas
      console.log("Enviando registro final a Sheets:", payload);

      await fetch(scriptURL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8',
        },
        body: JSON.stringify(payload)
      });

      alert('¡Brief y archivos registrados exitosamente en Google Drive y Sheets!');
      cleanForm();

    } catch (error) {
      console.error('Error durante el proceso:', error);
      alert('Hubo un problema al procesar el envío: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cleanForm = () => {
    setFormData({
      // 1. Datos Generales
      nombreEvento: '', fechaEvento: '', fechaLimite: '', presupuesto: '',
      empresa: '', sitioWeb: '', descripcionProducto: '',

      // 2. Características del Espacio
      noStand: '', medidasStand: '', tipoStand: '', niveles: '', alturaMaxima: '',

      // 3. Identidad y Materiales
      infoAdicional: '', visualizacionStand: '',

      // 4. Distribución y Necesidades
      counter: '', bodega: '', bodegaEquipamiento: [], frigobar: '',
      zonaNetworking: [], zonaLounge: '', rigging: '',
      activacion: '', activacionDetalle: '', papeleria: '', tipoPapeleria: '',
      contactos: '', basura: '', otroEspacio: '', otroEspacioDetalle: '',

      // 5. Exhibición de Producto
      tipoProducto: [], pesoEstimado: '', tipoExhibicion: [], exhibicionOtroDetalle: '',

      // 6. Tecnología, Servicios y Acabados
      pantallasTv: '', pantallasLed: '', pantallasTouch: '', lentesVr: '', tabletas: '',
      equipoSonido: false, serviciosTecnicos: [], acabadosPiso: []
    })
  }

  // Renderizador auxiliar (helper) para botones tipo Chip (Radios)
  const renderRadioChips = (name, options) => (
    <div className="d-flex flex-wrap gap-2 mt-2">
      {options.map((opt, idx) => {
        const id = `${name}-${idx}`;
        return (
          <React.Fragment key={id}>
            <input type="radio" className="btn-check" name={name} id={id} value={opt} checked={formData[name] === opt} onChange={handleChange} />
            <label className="btn btn-outline-primary" htmlFor={id}>{opt}</label>
          </React.Fragment>
        );
      })}
    </div>
  );

  // Renderizador auxiliar (helper) para botones tipo Chip (Checkboxes en arreglo)
  const renderCheckboxChips = (category, options) => (
    <div className="d-flex flex-wrap gap-2 mt-2">
      {options.map((opt, idx) => {
        const id = `${category}-${idx}`;
        const isChecked = formData[category].includes(opt);
        return (
          <React.Fragment key={id}>
            <input type="checkbox" className="btn-check" id={id} checked={isChecked} onChange={() => handleArrayChange(category, opt)} />
            <label className="btn btn-outline-primary" htmlFor={id}>{opt}</label>
          </React.Fragment>
        );
      })}
    </div>
  );


  return (
    <div className="container py-5" style={{ maxWidth: '820px' }}>
      <div className="text-center mb-5 mt-0">
        <div align="center">
          <img src={logo} alt="afirmativo" className='logo' />
        </div>
        <h1 className="fw-bolder mb-3" style={{ color: 'var(--afirmativo-primary)', letterSpacing: '-0.03em' }}>
          Brief de Diseño y Construcción
        </h1>
        <p style={{ color: 'var(--afirmativo-text-muted)', fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto' }}>
          Ingresa los detalles para el desarrollo conceptual, renders 3D y cotización de tu propuesta espacial.
        </p>
      </div>

      <form onSubmit={handleSubmit}>

        {/* 1. DATOS GENERALES Y TIEMPOS */}
        <div className="card shadow-sm mb-4 border-0">
          <div className="card-body p-4">
            <h5 className="card-title text-primary fw-bold border-bottom pb-2 mb-4 text-uppercase">1. Datos Generales y Tiempos</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-bold">Nombre de evento</label>
                <input type="text" className="form-control" name="nombreEvento" value={formData.nombreEvento} onChange={handleChange} placeholder="Ej. Food Tech Summit 2026" />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Fecha de evento</label>
                <input type="date" className="form-control" name="fechaEvento" value={formData.fechaEvento} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Fecha límite de propuesta</label>
                <input type="date" className="form-control" name="fechaLimite" value={formData.fechaLimite} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Presupuesto estimado</label>
                <input type="text" className="form-control" name="presupuesto" value={formData.presupuesto} onChange={handleChange} placeholder="Ej. $150,000 MXN" />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Empresa que expondrá</label>
                <input type="text" className="form-control" name="empresa" value={formData.empresa} onChange={handleChange} placeholder="Nombre comercial" />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Página web de la marca</label>
                <input type="url" className="form-control" name="sitioWeb" value={formData.sitioWeb} onChange={handleChange} placeholder="https://tuempresa.com" />
              </div>
              <div className="col-12">
                <label className="form-label fw-bold">Descripción del producto o servicio</label>
                <textarea className="form-control" rows="2" name="descripcionProducto" value={formData.descripcionProducto} onChange={handleChange} placeholder="Resuymen del giro o producto estrella"></textarea>
              </div>
            </div>
          </div>
        </div>

        {/* 2. CARACTERÍSTICAS DEL ESPACIO */}
        <div className="card shadow-sm mb-4 border-0">
          <div className="card-body p-4">
            <h5 className="card-title text-primary fw-bold border-bottom pb-2 mb-4 text-uppercase">2. Características del Espacio</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label fw-bold">No. de Stand</label>
                <input type="text" className="form-control" name="noStand" value={formData.noStand} onChange={handleChange} placeholder="Ej. 412" />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">Medidas (Frente x Fondo)</label>
                <input type="text" className="form-control" name="medidasStand" value={formData.medidasStand} onChange={handleChange} placeholder="Ej. 6m x 3m" />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">Altura máxima permitida (m)</label>
                <input type="number" step="0.1" className="form-control" name="alturaMaxima" value={formData.alturaMaxima} onChange={handleChange} placeholder="Ej. 5.0" />
              </div>
              <div className="col-12">
                <label className="form-label fw-bold">Tipo de Stand</label>
                {renderRadioChips('tipoStand', ['Esquina', 'Isla', 'Cabecera o Península', 'Cajón'])}
              </div>
              <div className="col-12">
                <label className="form-label fw-bold">Niveles</label>
                {renderRadioChips('niveles', ['1 Nivel', '2 Niveles (Mezzanine)'])}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Plano de ubicación (PDF/Imagen)</label>
                <label className="file-drop w-100">
                  <input
                    type="file"
                    className="d-none"
                    accept=".pdf, image/png, image/jpeg"
                    onChange={(e) => handleFileChange(e, 'planoUbicacion')}
                  />
                  {formData.planoUbicacion
                    ? `✅ Archivo cargado: ${formData.planoUbicacion?.fileName}`
                    : 'Arrastra el plano aquí o haz clic para subir'}
                </label>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Manual de expositor (PDF)</label>
                <label className="file-drop w-100">
                  <input
                    type="file"
                    className="d-none"
                    accept=".pdf, image/png, image/jpeg"
                    onChange={(e) => handleFileChange(e, 'manualExpositor')}
                  />
                  {formData.manualExpositor
                    ? `✅ Archivo cargado: ${formData.manualExpositor?.fileName}`
                    : 'Arrastra el manual aquí o haz clic para subir'}
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* 3. IDENTIDAD Y MATERIALES DE MARCA */}
        <div className="card shadow-sm mb-4 border-0">
          <div className="card-body p-4">
            <h5 className="card-title text-primary fw-bold border-bottom pb-2 mb-4 text-uppercase">3. Identidad y Materiales de Marca</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-bold">Manual de identidad</label>
                <label className="file-drop w-100">
                  <input
                    type="file"
                    className="d-none"
                    accept=".pdf, image/png, image/jpeg"
                    onChange={(e) => handleFileChange(e, 'manualIdentidad')}
                  />
                  {formData.manualIdentidad
                    ? `✅ Archivo cargado: ${formData.manualIdentidad?.fileName}`
                    : 'Arrastra el manual aquí o haz clic para subir'}
                </label>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Logotipos (PNG/Vectores)</label>
                <label className="file-drop w-100">
                  <input
                    type="file"
                    className="d-none"
                    accept=".pdf, image/png, image/jpeg"
                    onChange={(e) => handleFileChange(e, 'logotipo')}
                  />
                  {formData.logotipo
                    ? `✅ Archivo cargado: ${formData.logotipo?.fileName}`
                    : 'Arrastra el logotipo aquí o haz clic para subir'}
                </label>
              </div>
              <div className="col-12">
                <label className="form-label fw-bold">Información adicional / referencias (Enlaces)</label>
                <textarea className="form-control" rows="2" name="infoAdicional" value={formData.infoAdicional} onChange={handleChange} placeholder='Enlaces de Drive, Pinterest, Vimeo o archivos descriptivos'></textarea>
              </div>
              <div className="col-12">
                <label className="form-label fw-bold">Describe lo que quieres visualizar en tu stand</label>
                <textarea className="form-control" rows="2" name="visualizacionStand" value={formData.visualizacionStand} onChange={handleChange} placeholder='Detalle de atmósfera, colores, acabados deseados, o conceptos específicos'></textarea>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Visualización y referencias del stand</label>
                <label className="file-drop w-100">
                  <input
                    type="file"
                    className="d-none"
                    accept=".pdf, image/png, image/jpeg"
                    onChange={(e) => handleFileChange(e, 'reference')}
                  />
                  {formData.reference
                    ? `✅ Archivo cargado: ${formData.reference?.fileName}`
                    : 'Subir imágenes de referencia / moodboard'}
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* 4. DISTRIBUCIÓN Y NECESIDADES DEL ESPACIO */}
        <div className="card shadow-sm mb-4 border-0">
          <div className="card-body p-4">
            <h5 className="card-title text-primary fw-bold border-bottom pb-2 mb-4 text-uppercase">4. Distribución y Necesidades</h5>
            <div className="row g-4">
              <div className="col-md-4">
                <label className="form-label fw-bold m-0">Counter / Recepción</label>
                {renderRadioChips('counter', ['Sí', 'No'])}
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold m-0">Frigobar</label>
                {renderRadioChips('frigobar', ['Sí', 'No'])}
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold m-0">Zona lounge</label>
                {renderRadioChips('zonaLounge', ['Sí', 'No'])}
              </div>
              <div className="col-md-12">
                <label className="form-label fw-bold m-0">Bodega</label>
                {renderRadioChips('bodega', ['Sí', 'No'])}
                {formData.bodega === 'Sí' && (
                  <div className="mt-2 p-3 bg-light rounded">
                    <label className="form-label fw-bold mb-1">Equipamiento:</label>
                    {renderCheckboxChips('bodegaEquipamiento', ['Racks en bodega', 'Repisas en bodega', 'Percheros en bodega'])}
                  </div>
                )}
              </div>
              <div className="col-12">
                <label className="form-label fw-bold m-0">Zona de networking</label>
                {renderCheckboxChips('zonaNetworking', ['Periqueras', 'Sillas con mesa', 'Barra', 'Propuesta abierta'])}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold m-0">Copete colgante (Rigging)</label>
                {renderRadioChips('rigging', ['Sí', 'No'])}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold m-0">Activación interactiva</label>
                {renderRadioChips('activacion', ['Sí', 'No'])}
                {formData.activacion === 'Sí' && (
                  <input type="text" className="form-control mt-2" name="activacionDetalle" value={formData.activacionDetalle} onChange={handleChange} placeholder="Ej. Ruleta de premios" />
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold m-0">Contactos para recarga</label>
                {renderRadioChips('contactos', ['Sí', 'No'])}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold m-0">Botes de basura</label>
                {renderRadioChips('basura', ['Sí', 'No'])}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold m-0">Papelería a exhibir</label>
                {renderRadioChips('papeleria', ['Sí', 'No'])}
                {formData.papeleria === 'Sí' && (
                  <div className="mt-2 p-3 bg-light rounded">
                    <label className="form-label fw-bold mb-1">Tipo:</label>
                    {renderRadioChips('tipoPapeleria', ['Folletero', 'Revistero', 'Ambos'])}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold m-0">Otro elemento</label>
                {renderRadioChips('otroEspacio', ['Sí', 'No'])}
                {formData.otroEspacio === 'Sí' && (
                  <input type="text" className="form-control mt-2" name="otroEspacioDetalle" value={formData.otroEspacioDetalle} onChange={handleChange} placeholder="Especifica qué requieres" />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* 5. EXHIBICIÓN DE PRODUCTO */}
        <div className="card shadow-sm mb-4 border-0">
          <div className="card-body p-4">
            <h5 className="card-title text-primary fw-bold border-bottom pb-2 mb-4 text-uppercase">5. Exhibición de Producto</h5>
            <div className="row g-4">
              <div className="col-12">
                <label className="form-label fw-bold m-0">Tipo de producto</label>
                {renderCheckboxChips('tipoProducto', ['Físico pequeño', 'Voluminoso / Pesado', 'Frágil', 'Exposición de maqueta'])}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Peso estimado de maquinaria (kg)</label>
                <input type="text" className="form-control" name="pesoEstimado" value={formData.pesoEstimado} onChange={handleChange} placeholder="Ej. 450 kg" />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Ficha técnica / Listado</label>
                <label className="file-drop w-100">
                  <input
                    type="file"
                    className="d-none"
                    accept=".pdf, image/png, image/jpeg"
                    onChange={(e) => handleFileChange(e, 'fichaTecnica')}
                  />
                  {formData.fichaTecnica
                    ? `✅ Archivo cargado: ${formData.fichaTecnica?.fileName}`
                    : 'Arrastra la ficha técnica aquí o haz clic para subir'}
                </label>
              </div>
              <div className="col-12">
                <label className="form-label fw-bold m-0">Tipo de exhibición</label>
                {renderCheckboxChips('tipoExhibicion', ['Repisas', 'Tótem o glorificadores', 'Vitrinas (con/sin llave)', 'Propuesta abierta', 'Otro'])}
                {formData.tipoExhibicion.includes('Otro') && (
                  <input type="text" className="form-control mt-2" name="exhibicionOtroDetalle" value={formData.exhibicionOtroDetalle} onChange={handleChange} placeholder="Especifica tipo de exhibición" />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* 6. TECNOLOGÍA, SERVICIOS Y ACABADOS */}
        <div className="card shadow-sm mb-4 border-0">
          <div className="card-body p-4">
            <h5 className="card-title text-primary fw-bold border-bottom pb-2 mb-4 text-uppercase">6. Tecnología, Servicios y Acabados</h5>
            <div className="row g-4">
              <div className="col-12">
                <label className="form-label fw-bold">Equipo Audiovisual</label>
                <div className="row g-2">
                  <div className="col-md-4 col-sm-6"><input type="text" className="form-control" name="pantallasTv" value={formData.pantallasTv} onChange={handleChange} placeholder="Pantallas TV (Cant.)" /></div>
                  <div className="col-md-4 col-sm-6"><input type="text" className="form-control" name="pantallasLed" value={formData.pantallasLed} onChange={handleChange} placeholder="Pantallas LED (Medida)" /></div>
                  <div className="col-md-4 col-sm-6"><input type="text" className="form-control" name="pantallasTouch" value={formData.pantallasTouch} onChange={handleChange} placeholder="Pantallas Touch (Cant.)" /></div>
                  <div className="col-md-4 col-sm-6"><input type="text" className="form-control" name="lentesVr" value={formData.lentesVr} onChange={handleChange} placeholder="Lentes VR (Cant.)" /></div>
                  <div className="col-md-4 col-sm-6"><input type="text" className="form-control" name="tabletas" value={formData.tabletas} onChange={handleChange} placeholder="Tabletas (Cant.)" /></div>
                </div>
                <div className="mt-3">
                  <input type="checkbox" className="btn-check" id="equipoSonido" name="equipoSonido" checked={formData.equipoSonido} onChange={handleChange} />
                  <label className="btn btn-outline-primary" htmlFor="equipoSonido">Equipo de Sonido</label>
                </div>
              </div>
              <div className="col-md-12">
                <label className="form-label fw-bold m-0">Servicios Técnicos</label>
                {renderCheckboxChips('serviciosTecnicos', ['Bajada de Luz 110V', 'Luz Bifásica/Trifásica 220V', 'Ventiladores'])}
              </div>
              <div className="col-md-12">
                <label className="form-label fw-bold m-0">Acabados de piso</label>
                {renderCheckboxChips('acabadosPiso', ['Alfombra', 'Piso laminado', 'Floor Graphic', 'Propuesta abierta'])}
              </div>
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100 py-3 fw-bold fs-5 shadow-sm"
          disabled={isLoading}
        >
          {isLoading ? 'Enviando archivos e información...' : 'Enviar Brief de Stand'}
        </button>
      </form>
    </div>
  );
};

export default App;